var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 5.33203C11.7282 5.33203 12.7456 5.75346 13.4957 6.5036C14.2459 7.25375 14.6673 8.27116 14.6673 9.33203V13.9987H12.0007V9.33203C12.0007 8.97841 11.8602 8.63927 11.6101 8.38922C11.3601 8.13917 11.0209 7.9987 10.6673 7.9987C10.3137 7.9987 9.97456 8.13917 9.72451 8.38922C9.47446 8.63927 9.33398 8.97841 9.33398 9.33203V13.9987H6.66732V9.33203C6.66732 8.27116 7.08874 7.25375 7.83889 6.5036C8.58904 5.75346 9.60645 5.33203 10.6673 5.33203Z",
    stroke: "#57606A",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00065 5.9987H1.33398V13.9987H4.00065V5.9987Z",
    stroke: "#57606A",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66732 3.9987C3.4037 3.9987 4.00065 3.40174 4.00065 2.66536C4.00065 1.92898 3.4037 1.33203 2.66732 1.33203C1.93094 1.33203 1.33398 1.92898 1.33398 2.66536C1.33398 3.40174 1.93094 3.9987 2.66732 3.9987Z",
    stroke: "#57606A",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOutline);
export default __webpack_public_path__ + "static/media/linkedin-outline.a0096e4f5881098aeeca0ade11f3c433.svg";
export { ForwardRef as ReactComponent };